import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { QToggle, QIcon, QTooltip } from 'quasar';

import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-switch',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QToggle,
        QIcon,
        QTooltip,
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        translatedhint: function () {
            return this.Translate(this.hintText);
        }
    },
    methods: {
    },
    render() {        
        let icon;
        if (this.hintText) {
            icon = (
                <QIcon size="xs" class="q-pl-sm form-hint-icon" name="mdi-information">
                    <QTooltip transition-show="scale" transition-hide="scale" class="text-body2">{this.translatedhint}</QTooltip>
                </QIcon>
            );
        }

        let slots = {
            default: () =>
                <span>
                    <TranslationContainer context={this} value={this.labelText}></TranslationContainer>
                    {icon}
                </span>,
        }
        
        let input = (
            <QToggle
                class="caption q-pa-none q-ma-none"
                style="margin-bottom: 16px;"
                outlined
                dense
                hide-bottom-space
                modelValue={this.itemvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                disable={!!this.appearance?.readonly}
                onUpdate:modelValue={(value) => { this.sync(value == true); }}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</QToggle>
        );

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);
        //input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;
    }
});